import { render, staticRenderFns } from "./VDesignUsersSelect.vue?vue&type=template&id=6c4f5d0f&"
import script from "./VDesignUsersSelect.vue?vue&type=script&lang=ts&"
export * from "./VDesignUsersSelect.vue?vue&type=script&lang=ts&"
import style0 from "./VDesignUsersSelect.vue?vue&type=style&index=0&id=6c4f5d0f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports